module.exports = __webpack_public_path__ + "img/d0d6d61.png";